import { produce } from 'immer';
import { orderBy } from 'lodash';

import { SortInternalMarketers } from '../../../actions/marketers/internal/sortInternalMarketers';
import { routeMarketersToKeyMap } from '../../../service/MarketersHelper';
import { Marketer, MarketersState } from '../../../typings/marketers';

export function sortInternalMarketers(state: MarketersState, action: SortInternalMarketers): MarketersState {
    return produce(state, draft => {
        draft.marketers = orderBy<Marketer>(
            draft.marketers,
            [routeMarketersToKeyMap[action.sortParams.key]],
            [action.sortParams.direction]
        );
    });
}
